module.exports = __webpack_public_path__ + "static/media/arrow.2b1df315.svg";